<template>
  <div class="pincode-cnt">
    <header class="inner-header">
      <div class="head-title">
        <img src="../assets/images/logo.svg" />
      </div>
    </header>
    <div class="mid-cnt">
      <div class="pincode-container">
        <h3>किन पिन्कोडेस पर आप अपना ad चलाना चाहते हैं?</h3>
        <p>आप पिनकोड डालकर देख सकते है की आपकी ads कितने लोगो तक पहुंचेगी!</p>
        <div class="field-row">
          <div class="pin-area">
            <ul id="chiplist" class="chiplisting">
              <li  v-for="(pin, index) in pincodesList"
        :key="index">
                <span class="text-label">{{pin}}</span>
                <span class="remove-pin" @click="pincodesList.splice(index,1)"> </span>
              </li>
            </ul>
            <input
              type="number"
              id="text_val"
              placeholder="Type Pin & Enter"
              autofocus
              @keyup="(event)=>handlePincode(event.target.value)"
            />
          </div>
          <span class="error-msg" v-if="errMessage">{{errMessage}}</span>
          <div class="audience-counter">
            <p>कुल लोग</p>
            <span class="total-val" v-if="pincodeDetail">{{pincodeDetail.userCount}}</span>
            <span class="total-val" v-if="!pincodeDetail">0,00,000</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <span class="note-msg">लोगो तक अपनी ad पहुंचाने के लिए</span>
      <span class="ftr-btn" @click="handlePincodeCovers">
        प्रोसीड करे
      </span>
    </div>
    <loadingIcon v-if="loading" />
    <Toaster :dataValue="toasterData" />
  </div>
</template>

<script>
import Toaster from "../components/Toaster";
import loadingIcon from "../components/icons/loadingIcon";
export default {
  name: "Pincode",
  components: {
    Toaster,
    loadingIcon,
  },
  mounted() {},
  data() {
    return {
      pincodesList: [],
      errMessage: '',
      pincodeDetail: null,
      loading: false,
      toasterData:{},
      disable: false
    };
  },
  methods: {
    handlePincode(value){
      if(value.length === 6){
        this.pincodesList.push(value)
        this.errMessage = ''
        document.getElementById('text_val').value = ''
      }else{
        this.errMessage = 'Please input pincode of 6 digit number'
      }
    },
    handlePincodeCovers(){
      this.loading = true
      this.disable = true
      this.$store.dispatch({type:'PincodeSupport', payload:this.pincodesList.join(',')}).then((data)=>{
        console.log('=data==',data)
        if (data.httpStatus) {
        this.disable = false;
        this.loading = false
        if(data.httpStatus === 200){
            this.pincodeDetail = data.data
            setTimeout(()=>{
              this.$router.push(`/create-ad-form?intent=${this.$route.query.intent}&MediaType=${this.$route.query.MediaType}`)
            },3000)
        }
        this.toasterData = {
          status: true,
          msg: data.message,
          timeoutMs: "5000",
          color: "#ff6600",
        };
      }
      })
    }
  },
};
</script>
